import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { getAccessToken, getRefreshToken } from '@ecp/common/src/utils/utils';

import UserInfoProvider from '@mo-components/common/provider/UserInfoProvider';
import useSiteInfo from '@mo-hooks/common/useSiteInfo';
import GuestRoutes from '@ecp/mo/src/routes/GuestRoutes';

const ProtectedRoutes = () => {
  const accessToken = getAccessToken();
  const refreshToken = getRefreshToken();
  const { isNoMemberUseYn } = useSiteInfo();
  const { pathname } = useLocation();

  const notLoggedInRoutes = () => {
    switch (isNoMemberUseYn) {
      case true:
        return <GuestRoutes />;
      case false:
        return <Navigate to="/login" state={{ prev: pathname + location.search, current: '/login' }} />;
      default:
        return <></>;
    }
  }

  return accessToken && refreshToken ? (
    <UserInfoProvider>
      <Outlet />
    </UserInfoProvider>
  ) : (notLoggedInRoutes());
};

export default ProtectedRoutes;
